import { render, staticRenderFns } from "./giftSet.vue?vue&type=template&id=7e49898e&scoped=true&"
import script from "./giftSet.vue?vue&type=script&lang=js&"
export * from "./giftSet.vue?vue&type=script&lang=js&"
import style0 from "./giftSet.vue?vue&type=style&index=0&id=7e49898e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e49898e",
  null
  
)

export default component.exports